import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { fetchAnalyticTeamReportConfigAction } from '../fetchTeamReportConfig/action';
import { backendClient } from '../../../../services/api/backend-client';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';

export function* updateTeamReportConfigSaga(action) {
  try {
    const { id, teamId, ...updateData } = action.payload;
    
    if (!id) {
      throw new Error('Report ID is required');
    }
    
    if (!teamId) {
      throw new Error('Team ID is required');
    }
    
    yield call([backendClient, backendClient.patch], `reports/${id}`, updateData);
    
    yield put(fetchAnalyticTeamReportConfigAction({ teamId }));
    
    yield put(showSnackbar({
      message: 'Report updated successfully',
      severity: 'success',
    }));
  } catch (err) {
    bugsnagClient.notify(err);
    console.error('Failed to update analytic team report configuration', err?.message);
    yield put(showSnackbar({
      message: 'Failed to update report',
      severity: 'error',
    }));
  }
}